import React, { useState }    from 'react';
import { ISearchInputValues } from '@typings/components';
import { useFetchAccounts }   from '@modules/accountManagement/queries/accountQueries';
import { AccountSearchPage }  from '@modules/accountManagement/pages/AccountSearchPage';

export const AccountSearchContainer: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');

  // #region INTEGRATE API
  const { data: accounts = [], isLoading } = useFetchAccounts(searchQuery);
  // #endregion

  return (
    <AccountSearchPage
      accounts         = {accounts}
      isLoading        = {isLoading}
      searchQuery      = {searchQuery}
      handleSearchText = {({ searchText }: ISearchInputValues) => setSearchQuery(searchText)}
    />
  );
};
